import { useMemo } from 'react';
import { useCalendarStore } from '../store/useCalendarStore';
import { useParams } from 'react-router-dom';
import { splitCalendarByMonth } from '../utils/split-calendar-by-month';
import { months } from '../utils/months-list';

export const useCalendarDays = () => {
  const { month } = useParams();
  const currentMonth = useMemo(() => months.findIndex((m) => m.toLowerCase() === month), [month]);
  const { calendar } = useCalendarStore();
  const calendarByMonth = useMemo(() => {
    return splitCalendarByMonth(calendar);
  }, [calendar]);

  const monthsGroupped = currentMonth === -1 ? calendarByMonth : [calendarByMonth[currentMonth]];

  return {
    monthsGroupped,
  };
};
